angular.module('billing').controller('PaymentFromConsentCtrl',
                ['$scope', '$state','$stateParams', 'BillingRepository', 'PatientPortalStorageRepository', 'BillingService', 'toaster', 'aprgettext', 'TransitionManager', '$uibModal',
        function ($scope,   $state,  $stateParams,   BillingRepository,   PatientPortalStorageRepository,   BillingService,   toaster,   gettext,      TransitionManager,   $modal) {

            'use strict';

            var loginUserId = PatientPortalStorageRepository.getLoginUser().id;
            $scope.loadingPaymentHistory = true;
            $scope.loadingBillingAccount = true;
            $scope.submitPaymentLoading = false;
            $scope.responsiblePartyBilling = [];
            $scope.chargeRegEx = /^\d*[.]?(\d{0,2})?$/;
            $scope.payment = {
                HasCardOnFile: false,
                ChargeAmount: '',
                PersonBalanceAll: '',
                ConsentAnnual: null
            };

            $scope.statementsOnly = getState();

            function getState()
            {
                return $state.current.alternativeLoginRoute;
            }

            function loadPage() {
                loginUserId = PatientPortalStorageRepository.getLoginUser().id;
                loadBillingAccount();
            }

            function loadBillingAccount() {
                $scope.loadingBillingAccount = true;
                $scope.removeHttpError();
                var requestDto = {
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString()
                };

                BillingService
                    .getBillingAccount(requestDto)
                    .then(function (billingAccountDto) {
                        $scope.payment.PersonBalanceAll = billingAccountDto.PersonBalanceAll;
                        if (billingAccountDto.ConsentAnnual) {
                            $scope.payment.ConsentAnnual = billingAccountDto.ConsentAnnual;
                            if (parseFloat($scope.payment.ConsentAnnual.PerChargeLimit) < parseFloat($scope.payment.ConsentAnnual.RemainingInConsent)) {
                                $scope.maxPaymentAmount = $scope.payment.ConsentAnnual.PerChargeLimit;
                            } else {
                                $scope.maxPaymentAmount = $scope.payment.ConsentAnnual.RemainingInConsent;
                            }
                            $scope.payment.HasCardOnFile = true;
                        }
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loadingBillingAccount = false;
                    });
            }

            function submit() {
                if ($scope.paymentFromConsentForm.$invalid) {
                    return;
                }

                $scope.modalPrint = true;
                var modalInstance = $modal.open({
                    templateUrl: '/billing/views/modals/confirmPaymentModal.html',
                    controller: 'ConfirmPaymentModalCtrl',
                    resolve: {
                        consentAnnual: function () {
                            return $scope.payment.ConsentAnnual;
                        },
                        chargeAmount: function () {
                            return $scope.payment.ChargeAmount;
                        }
                    }
                });

                modalInstance.result.then(function (result) {
                    if (result === 'accept') {
                        postPayment();
                    }
                });
            }

            function postPayment() {
                $scope.submitPaymentLoading = true;
                var consentAnnualRequestDto = {
                    ConsentAnnualId: $stateParams.consentId,
                    PaymentAmount: $scope.payment.ChargeAmount,
                    ApplicationSubmittingPayment: '1', //enum SourceOfPayments.PatientPortal
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString(),
                    FinancialCenter: $stateParams.financialCenterUid,
                };

                BillingRepository.postConsentAnnualPayment(consentAnnualRequestDto)
                    .then(function (data) {
                        $scope.statementsOnly = getState();
                        if($scope.statementsOnly){
                        TransitionManager.transition({appRoute: 'paymentSummaryStatementsOnly', opts: {txId: data.TxId}});
                        }
                        else {
                            TransitionManager.transition({appRoute: 'paymentSummary', opts: {txId: data.TxId}});
                        }
                    })
                    .catch(function (response) {
                        toaster.pop('error', '', gettext('An error occurred while submitting the payment'));
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.submitPaymentLoading = false;
                    });
            }

            $scope.postPayment = postPayment;
            $scope.submit = submit;
            loadPage();
        }
    ]);